import {Alert} from 'antd';
import React from 'react';

export function PredictionConfigurationAlert() {
	return (
		<Alert
			description={
				<ul>
					<li>
						The predicted timeframe will be exactly as long as the qualification duration of the profile plus the intervention
						buffer
					</li>
					<li>Only the upper and lower limit from the alarm limit are taken into account</li>
					<li>The delay of the alarm limit is discarded</li>
					<li>The lane will begin with the first measurement</li>
					<li>Allow new run by START button - is not supported</li>
					<li>Notifications will only be sent, if an Alarm Profile is configured for the sensor</li>
				</ul>
			}
			type="warning"
		/>
	);
}
